/* eslint-disable no-case-declarations */
import {
  CAMPAIGN_REQUEST,
  CAMPAIGN_LIST_SUCCESS,
  CAMPAIGN_FAIL,
  CAMPAIGN_EDIT_SUCCESS,
  CAMPAIGN_ADD_SUCCESS,
  CAMPAIGN_DELETE_SUCCESS,
  SAVE_CAMPAIGN_FILTER,
  SELECTED_CONTACTS_FOR_CAMPAIGN,
  SELECTED_CAMPAIGN,
  EMPTY_CAMPAIGN,
  CAMPAIGN_GET_ONE_SUCCESS,
} from "./constants";

const initialState = {
  canFetchMoreCampaign: true,
  prevCampaigns: [],
  selectedCampaign: {},
  success: false,
  loading: false,
  contacts: [],
  filter: {},
  campaignsCount: 0,
  campType: "all",
  error: {
    type: "",
    message: "",
  },
};

const campaignsReducer = (state = initialState, action) => {
  const { type, payload, filter, contacts, selectedCampaign, campaignsCount, haveCmp } = action;
  switch (type) {
    case CAMPAIGN_REQUEST:
      return { ...state, loading: true, error: { ...initialState.error }, success: false };

    case CAMPAIGN_GET_ONE_SUCCESS:
      return {
        ...state,
        loading: false,
        prevCampaigns: [payload],
      };

    case CAMPAIGN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        prevCampaigns: payload,
        campaignsCount,
        haveCmp,
      };
    case CAMPAIGN_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        prevCampaigns: [
          ...state.prevCampaigns.map((campaign) =>
            campaign._id === payload._id ? { ...payload } : campaign,
          ),
        ],
        success: true,
      };
    case CAMPAIGN_ADD_SUCCESS: {
      const newCampaignsArray = state.prevCampaigns.filter(
        (campaign) => campaign.task_id !== undefined,
      );

      newCampaignsArray.unshift(newCampaignsArray[0]);
      // newCampaignsArray.shift();

      return {
        ...state,
        loading: false,
        // prevCampaigns: updatedCampaignsArray,
        selectedCampaign: {},
        filter: {},
      };
    }
    case CAMPAIGN_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        prevCampaigns: state.prevCampaigns.filter((campaign) => campaign._id !== payload._id),
        success: true,
        selectedCampaign: {},
        filter: {},
      };
    case CAMPAIGN_FAIL:
      return { ...state, loading: false, error: { ...payload }, success: false };
    case SAVE_CAMPAIGN_FILTER: {
      return { ...state, filter };
    }
    case SELECTED_CONTACTS_FOR_CAMPAIGN: {
      return { ...state, contacts };
    }
    case SELECTED_CAMPAIGN:
      return { ...state, selectedCampaign };
    case EMPTY_CAMPAIGN:
      return { ...state, prevCampaigns: [], selectedCampaign: {} };

    default:
      return state;
  }
};

export default campaignsReducer;
